// src/components/MainContent/UploadForm/SubmitButton.jsx
import React from 'react';

const SubmitButton = ({ handleSubmit, disabled }) => (
  <button 
    className={`submit-button ${disabled ? 'disabled' : ''}`}
    onClick={handleSubmit}
    disabled={disabled}
  >
    Process Audio
  </button>
);

export default SubmitButton;